import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AppConfig from './plugins/AppConfig'

Vue.config.productionTip = false
Vue.use(AppConfig);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
